define('models/pages/trade/request/sub',['require','models/base/model','models/base/subscribe','models/base/sync-collection'],function(require) {
    'use strict';

    var Model = require('models/base/model'),
        SubscribeModel = require('models/base/subscribe'),
        SyncCollection = require('models/base/sync-collection');

    var fakeId = 0;

    var Sub = SubscribeModel.extend({
        action: 'requests.list',
        defaults: {
            key: 0
        },
        urlParams: function() {
            return {
                tradeId: this.get('tradeId')
            };
        },
        parse: function(data) {
            // this.items.set(data.items);
            data.fakeId = fakeId++;
            console.log('DATA', data);
            return data;
        }
    });

    return Sub;
});
